import { useState } from 'react'

// Back to the first page whenever the search changes, without an extra render.
export const usePageOf = (search: string) => {
  const [paging, setPaging] = useState({ search, page: 0 })
  return {
    page: paging.search === search ? paging.page : 0,
    setPage: (page: number) => setPaging({ search, page }),
  }
}
